
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import _extends from '../../../@babel/runtime/helpers/esm/extends.js';
import * as React from 'react';
import { forwardRef } from 'react';
import { S as Select } from '../../dist/Select-c7902d94.esm.js';
import { u as useStateManager } from '../../dist/useStateManager-7e1e8489.esm.js';
import { u as useCreatable } from '../../dist/useCreatable-bf6ebe1f.esm.js';
export { u as useCreatable } from '../../dist/useCreatable-bf6ebe1f.esm.js';
import 'react-dom';

var CreatableSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var creatableProps = useStateManager(props);
  var selectProps = useCreatable(creatableProps);
  return /*#__PURE__*/React.createElement(Select, _extends({
    ref: ref
  }, selectProps));
});
var CreatableSelect$1 = CreatableSelect;

export { CreatableSelect$1 as default };
//# sourceMappingURL=react-select-creatable.esm.js.map
